module.exports = __webpack_public_path__ + "assets/star.459539de.svg";